module.exports = __webpack_public_path__ + "img/icons-font.6a6d9c87.svg";